import { render, staticRenderFns } from "./feedListDetail.vue?vue&type=template&id=189a8078&scoped=true"
import script from "./feedListDetail.vue?vue&type=script&lang=js"
export * from "./feedListDetail.vue?vue&type=script&lang=js"
import style0 from "./feedListDetail.vue?vue&type=style&index=0&id=189a8078&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189a8078",
  null
  
)

export default component.exports